import { QueueStateModule } from '@/store/modules/queue/types';
import StorageQueueVisibility from '@/core/queues/StorageVisibility';

const state = (): QueueStateModule => ({
    queuesContainer: {},
    storageVisibility: {} as StorageQueueVisibility,
});
export default state;
